// src/components/ServiceSection/ServiceSection.jsx
import React from "react";

import services1 from "../../images/services1.jpeg";
import services2 from "../../images/services2.jpeg";
import services3 from "../../images/services3.jpeg";
import services4 from "../../images/services4.jpeg";

const ServiceSectionS2 = () => {
  const phoneDisplay = "703-662-3685";
  const phoneDial = phoneDisplay.replace(/[^0-9]/g, "");

  const proposalsEmail = "support@jmccontractinggroup.com";
  const subject = encodeURIComponent("Proposal Request");
  const body = encodeURIComponent(
    "Hi JMC Contracting Group,\n\nI’d like to request a proposal/estimate.\n\nProject Location:\nType of Work:\nDesired Start Date:\nBest Contact Name/Phone:\n\nAdditional Details:\n"
  );
  const mailtoHref = `mailto:${proposalsEmail}?subject=${subject}&body=${body}`;

  return (
    <>
      <div id="scrool"></div>

      <div className="services-wrapper">
        <div className="jmc-flyer">
          {/* Top photo strip */}
          <div className="jmc-strip">
            <img src={services3} alt="JMC work 1" />
            <img src={services1} alt="JMC work 2" />
            <img src={services4} alt="JMC work 3" />
          </div>

          {/* Title band */}
          <div className="jmc-title-band">
            <h1>
              Property Maintenance
              <span>&amp; Restoration Services</span>
            </h1>
          </div>

          {/* Sub text */}
          <div className="jmc-band-sub">
            <strong>JMC Contracting Group LLC</strong> provides{" "}
            <strong>Janitorial</strong>, <strong>Maintenance</strong>, and{" "}
            <strong>Construction</strong> services for{" "}
            <strong>commercial and residential</strong> properties with repairs,
            rebuilds, improvements, and emergency response.
          </div>

          {/* Flyer body */}
          <div className="jmc-body">
            <div className="jmc-body-grid">
              {/* LEFT: Bullet list */}
              <div className="jmc-list">
                <h2>Construction Services</h2>
                <p>
                  From small repairs to full rebuilds, our crews handle the work with
                  clear communication, clean job sites, and durable finishes.
                </p>

                <ul className="jmc-bullets">
                  <li>Roofing &amp; Siding Repairs</li>
                  <li>Windows &amp; Doors</li>
                  <li>Concrete &amp; Flatwork</li>
                  <li>Drywall &amp; Painting</li>
                  <li>Framing &amp; Rebuilds</li>
                  <li>Water &amp; Fire Restoration Support</li>
                  <li>Emergency Response &amp; Temporary Protection</li>
                  <li>Preventive Maintenance &amp; Repair Contracts</li>
                  <li>Playground Repairs / Replacement</li>
                  <li>Line Striping &amp; Parking Lot Touch-Ups</li>
                  <li>Sport Court Refurbishment</li>
                  <li>Fencing &amp; Gates</li>
                  <li>Retaining Walls</li>
                  <li>Interior Renovations &amp; Turnovers</li>
                  <li>Common Area Repairs &amp; Improvements</li>
                </ul>

                {/* Email Proposals button (replaces /proposal route) */}
                <div style={{ marginTop: 18 }}>
                  <a className="service-btn" href={mailtoHref}>
                    Email Proposals: {proposalsEmail}
                  </a>
                </div>

                <div className="jmc-note">
                  Commercial • Residential • HOA / Condo Communities
                </div>
              </div>

              {/* RIGHT: Stacked images */}
              <div className="jmc-img-stack">
                <img src={services2} alt="JMC stacked 1" />
                <img src={services4} alt="JMC stacked 2" />
                <img src={services1} alt="JMC stacked 3" />
              </div>
            </div>

            {/* CTA bands */}
            <div className="jmc-cta-band">
              <h2>Call For A Free Estimate!</h2>
            </div>

            <div className="jmc-phone-band">
              <a href={`tel:${phoneDial}`}>{phoneDisplay}</a>
            </div>

            <div className="jmc-note">
              Licensed &amp; insured • Fast scheduling • Cleanup &amp; quality focus
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceSectionS2;